class UtilitiesService {
  public registerGlobal = (object: any, alias: string | string[]) => {
    if (alias instanceof Array) {
      alias.forEach((a) => (window as any)[a] = object);
    } else {
      (window as any)[alias] = object;
    }
  }
}

export default new UtilitiesService();
